export { ProductInfoBoxes } from './ProductInfoBoxes'
